// 是否是app访问
export const userAgent = window.navigator.userAgent.toLowerCase();
export const isAPLink = userAgent.includes('aplink');
export const isStarNest = userAgent.includes('starnest');
export const isApp = isAPLink || isStarNest;